<template>
  <div :class="$style.container">
    <div :class="$style.form">
      <simple-input
        v-model="form.name"
        :error="$v.form.name.$error"
        :placeholder="$t('deal.dispute.name')"
        :maxlength="50"
        @focus="$v.form.name.$reset"
        @blur="$v.form.name.$touch"
      />

      <div :class="[$style.section, { [$style.shadow]: isShownReason }]">
        <fieldset>
          <legend :class="$style.legend">
            {{ $t('deal.dispute.radio') }}
          </legend>
          <div :class="$style.groups">
            <radio-button
              v-model="form.received"
              :label="$t('deal.radio.yes')"
              value="yes"
            />
            <radio-button
              v-model="form.received"
              :label="$t('deal.radio.no')"
              value="no"
            />
          </div>
        </fieldset>
      </div>

      <simple-input
        v-show="isShownReason"
        v-model="form.reason"
        :error="$v.form.reason.$error"
        :placeholder="$t('deal.dispute.reason')"
        type="textarea"
        last-in-form
        @focus="$v.form.reason.$reset"
        @blur="$v.form.reason.$touch"
      >
        <help-link slot="icon-right" source="https://help.capusta.space/challenging" />
      </simple-input>
    </div>

    <div :class="$style.submit">
      <simple-button :disabled="!isValid" @click="handleSubmit">
        {{ $t('deal.dispute.submit') }}
      </simple-button>
    </div>
  </div>
</template>

<script>
import { required, minLength } from 'vuelidate/lib/validators';

import HelpLink from 'molecules/common/HelpLink';
import SimpleButton from 'molecules/common/SimpleButton';
import SimpleInput from 'molecules/common/SimpleInput';
import RadioButton from 'molecules/base/RadioButton';

export default {
  name: 'OpenDisputeForm',
  components: {
    HelpLink,
    SimpleButton,
    SimpleInput,
    RadioButton,
  },
  data() {
    return {
      isInvalidName: false,
      isInvalidReason: false,
      form: {
        name: '',
        reason: '',
        received: '',
      },
    };
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(2),
      },
      received: {
        required,
      },
      reason: {
        required,
        minLength: minLength(2),
      },
    },
  },
  computed: {
    isShownReason() {
      if (this.$validate.isEmptyString(this.form.received)) {
        return false;
      }

      return this.form.received === 'yes';
    },
    isValid() {
      if (this.$v.form.name.$invalid) {
        return false;
      }

      if (this.$v.form.received.$invalid) {
        return false;
      }

      if (this.isShownReason) {
        return !this.$v.form.reason.$invalid;
      }

      return true;
    },
  },
  watch: {
    'form.received': {
      handler(val) {
        if (val === 'no') {
          this.form.reason = '';
          this.$v.form.reason.$reset();
        }
      },
    },
  },
  methods: {
    handleSubmit() {
      if (!this.isValid) {
        return;
      }

      this.$emit('submit', {
        name: this.form.name,
        goodsReceived: this.form.received === 'yes',
        reason: this.$validate.isNotEmptyString(this.form.reason) ? this.form.reason : null,
      });
    },
  },
};
</script>

<style lang="sass" module>
  .container
    position: relative

  .form
    +base-card(true)
    margin-bottom: 20px

  .legend
    +form-legend
    margin-bottom: 15px
    color: rgba(33, 33, 33, 1)

  .groups
    display: flex

    label
      &:not(:last-child)
        margin-right: 30px

  .section
    padding: 15px

    &.shadow
      box-shadow: 0px 1px 0px rgba(189, 189, 189, 0.5)

    +respond-to(medium)
      padding: 20px
</style>
